import { createSlice, createAsyncThunk, createAction } from "@reduxjs/toolkit";
import bannerService from "./bannerService";

export const getBanners = createAsyncThunk(
  "banner/all",
  async (thunkAPI) => {
    try {
      return await bannerService.getBanners();
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const createBanner = createAsyncThunk(
  "banner/add",
  async (bannerData, thunkAPI) => {
    try {
      return await bannerService.createBanner(bannerData);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
// export const updateABanner = createAsyncThunk(
//   "banner/update",
//   async (banner, thunkAPI) => {
//     try {
//       return await bannerService.updateBanner(banner);
//     } catch (error) {
//       return thunkAPI.rejectWithValue(error);
//     }
//   }
// );

export const updateABanner = createAsyncThunk(
  "banner/update",
  async (banner, thunkAPI) => {
    try {
      return await bannerService.updateBanner(banner);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const deleteABanner = createAsyncThunk(
  "banner/delete",
  async (id, thunkAPI) => {
    try {
      return await bannerService.deleteBanner(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const getABanner = createAsyncThunk(
  "banner/get",
  async (id, thunkAPI) => {
    try {
      return await bannerService.getABanner(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const resetState = createAction("RevertAll");

const initialState = {
  banners: [],
  isError: false,
  isLoading: false,
  isSuccess: false,
  message: "",
};
export const bannerSlice = createSlice({
  name: "banners",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getBanners.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getBanners.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.banners = action.payload.data;
      })
      .addCase(getBanners.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(createBanner.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createBanner.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.createdBanner = action.payload;
      })
      .addCase(createBanner.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(updateABanner.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateABanner.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.updatedBanner = action.payload;
      })
      .addCase(updateABanner.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(deleteABanner.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteABanner.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.deletedbanner = action.payload.data;
      })
      .addCase(deleteABanner.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(getABanner.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getABanner.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.bannerName = action.payload.data.banner_title;
        state.bannerImage = action.payload.data.banner_image;
      })
      .addCase(getABanner.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(resetState, () => initialState);
  },
});
export default bannerSlice.reducer;
